export const COMPANY_STANDARD_NAME_PLACEHOLDER = 'company.standard.name';

export const clearMergeTagName = (name: string): string => {
  const chunks = name.split('.');
  return chunks[chunks.length - 1];
};
